import React from 'react'

import { MapsContext } from '../../../../components/map/MapContext'
import { UserAvatar } from '../../../../components/presentation/Avatar'
import Icon from '../../../../packages/kiti/components/shapes/Icon'
import Map from '../../../../components/map/Map'
import Modal from '../../../../components/structure/Modal'
import PinWrapper from '../../../../components/map/PinWrapper'
import UsersLoader, { useUsers } from './_load/UsersLoader'
import Tooltip from '../../../../packages/kiti/components/presentation/Tooltip'
import { COLORS } from '@btime/constants'

const UserMapPicker = ({ onSelect, onClose, address }) => {
  const users = useUsers()

  return (
    <MapsContext
      defaultCenter={!!address?.latitude && { lat: address?.latitude, lng: address?.longitude }}
      defaultZoom={12}
    >
      <Map noLock height="38rem" disableFullScreen>
        {!!address?.latitude && (
          <PinWrapper lat={address?.latitude} lng={address?.longitude}>
            <Icon name="RiMapPin2Fill" size={2} color="dark1" />
          </PinWrapper>
        )}
        {users.map(user => (
          <PinWrapper
            key={user.id}
            lat={user.addressFieldValue?.value?.latitude}
            lng={user.addressFieldValue?.value?.longitude}
            onClick={() => {
              onClose()
              onSelect(user)
            }}
          >
            <Tooltip label={user?.name} bgColor={COLORS.white}>
              <UserAvatar user={user} />
            </Tooltip>
          </PinWrapper>
        ))}
      </Map>
    </MapsContext>
  )
}

const Wrapper = ({ open, onClose, ...props }) => (
  <Modal open={open} onClose={onClose} noPadding width="72rem">
    <UsersLoader>
      <UserMapPicker onClose={onClose} {...props} />
    </UsersLoader>
  </Modal>
)

export default Wrapper
